module.exports = __webpack_public_path__ + "img/67.707a7966.png";